import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useAutosavingFormContext } from 'src/components/ConnectedInputs/AutosavingForm';
import { CinchUserPicker } from 'src/components/baseComponents/Inputs';

export const ConnectedCinchUserPicker = React.forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ name, rules, required, id, ...props }, ref) => {
    const { id: contextId } = useAutosavingFormContext();

    return (
      <Controller
        name={name}
        rules={{
          required,
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          <CinchUserPicker
            id={(id ?? contextId) ? `${contextId}.${name}` : name}
            {...props}
            name={name}
            value={value ?? null}
            onChange={(e, value) => {
              onChange(value);
            }}
            onBlur={onBlur}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

ConnectedCinchUserPicker.displayName = 'ConnectedCinchUserPicker';

ConnectedCinchUserPicker.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  rules: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
};
